import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { DwChildConfigBaseComponent, DwMetaDataConfigContext, DwMetaDataService, DwMetaDataServiceToken, DwQueryMetaData } from '@devwareapps/devware-cap';
import { AviatorAvatarColumnConfig } from '../models/aviator-avatar-column-config.model';

@Component({
  selector: 'app-aviator-avatar-column-config',
  templateUrl: './aviator-avatar-column-config.component.html',
  styleUrls: ['./aviator-avatar-column-config.component.scss']
})
export class AviatorAvatarColumnConfigComponent extends DwChildConfigBaseComponent<AviatorAvatarColumnConfig, DwMetaDataConfigContext> {
  getDefaultConfig(): AviatorAvatarColumnConfig {
    return {} as any;
  }
}
 